export const brandFonts = {
  primary: "'Open Sans', sans-serif",
  secondary: "'Ovo', serif",
  tertiary: 'Font',
};
